export enum MaritalStatusEnum {
  SingleMan = "A Single Man",
  SingleWoman = "A Single Woman",
  UnmarriedMan = "An Unmarried Man",
  UnmarriedWoman = "An Unmarried Woman",
  HusbandAndWife = "As Husband and Wife",
  TypeWifeAndHusband = "As Wife and Husband",
  NoMaritalStatusOption = "No Marital Status Option",
}

export enum VestingTypeEnum {
  SoleAndSeparatePropertyMarriedMan = "A Married Man, as His Sole and Separate Property",
  SoleAndSeparatePropertyMarriedWoman = "A Married Woman, as Her Sole and Separate Property",
  CommunityProperty = "As Community Property",
  CommunityPropertyWithROS = "As Community Property with Right of Survivorship",
  JointTenants = "As Joint Tenants",
  JointTenantsWithROS = "As Joint Tenants with Right of Survivorship",
  TenantsInCommon = "As Tenants in Common",
  TenantsInSeveralty = "As Tenants in Severalty",
  TenantsByTheEntirety = "As Tenants by the Entirety",
  Individual = "Individual",
  NoVestingType = "No Vesting Option",
}

export interface Vesting {
  type: string;
  toRead: string;
  maritalStatus: string;
  toReadSuggested: string;
}
